import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {NumOfPaymentsArr} from './Constant';
import {PortalStep} from './Enum';
import {setCurrentStep, setUserDetails} from './OrganizationPortalSlice';

import OrgFooterButtons from './OrgFooterButtons';
import {resetStore} from '../SaleBlock/PaymentCG/PaymentCGSlice';
import ReactSelect from '../../Shared/ReactSelect/ReactSelect';

function SelectNumOfPayment(props) {
  const [error, setError] = useState('');
  const [numOfPayments, setNumOfPayments] = useState(props.userDetails.payment.numOfPayments ?? '');

  useEffect(() => {
    if (props.modelPrice == 0) {
          props.setCurrentStep({current: PortalStep.OrderSummary, previous: props.steps.current});
    }
  }, []);

  const goToNextPage = async () => {
    if (numOfPayments) {
      props.setUserDetails({
        ...props.userDetails,
        payment: {
          ...props.userDetails.payment,
          numOfPayments: numOfPayments,
        },
      });
      props.setCurrentStep({current: PortalStep.OrderSummary, previous: props.steps.current});
    } else {
      setError('אנא בחר מספר תשלומים');
    }
  };

  return (
    <div className='Payment_info'>
      <div className='step-page_S'>
        <div className='M_Title'> בחירת מספר תשלומים</div>
        {props.userDetails.actionType === 'activate' && <div className='S_SubTitle'>אמצעי התשלום שהוזן נשמרו לביצוע ההזמנה. להחלפת אמצעי תשלום יש לפנות לאיש הקשר</div>}
          <div className='info_section'>
            <div className='numOfPayments'>
              <div className='subTitle'> סה"כ לתשלום : {props.modelPrice} ₪ </div>
              <ReactSelect
                getOptionLabel={(option) => option}
                getOptionValue={(option) => option}
                placeholder={numOfPayments || 'מספר תשלומים'}
                value={numOfPayments}
                name='NumOfPayments'
                error={error}
                options={NumOfPaymentsArr}
                onChange={(numOfPay) => {
                  setNumOfPayments(numOfPay);
                  setError('');
                }}
              />
            </div>
          </div>
      </div>
      <OrgFooterButtons btnText={'לסיום וצפייה בפרטי ההזמנה'} onContinue={() => goToNextPage()} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  userDetails: state.organizationPortal.userDetails,
  steps: state.organizationPortal.steps,
  modelPrice: state.organizationPortal.userDetails.selectedPlan.model.price,
});

const mapDispatchToProps = {
  setCurrentStep,
  setUserDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectNumOfPayment);
